import React, { useEffect, useState } from "react";

const useRecaptcha = () => {
  const [token, setToken] = useState("");

  useEffect(() => {
    window?.grecaptcha.ready(() => {
      // Execute reCAPTCHA once the library is loaded
      window.grecaptcha
        .execute("6LcQ88IpAAAAANAlYuHwl9AcZTXnPoj2AB70p4Cq")
        .then((token) => {
          // Use the reCAPTCHA token for form submission or further processing
          console.log("reCAPTCHA token:", token);
          if (token) {
            // console.log("token", token);
            setToken(token);
          }
        });
    });
  }, []);

  return [token];
};

export default useRecaptcha;
